import { memo, ReactNode } from "react"
import { Provider } from "wagmi"
import { Index } from "./home"
import { connectors } from "./hook/web3"

const Providers = memo(({ children }: { children: ReactNode }) => (
  <Provider autoConnect connectors={connectors}>
    {children}
  </Provider>
))

const App = memo(() => {
  return (
    <Providers>
      <div className="container h-screen">
        <Index />
      </div>
    </Providers>
  )
})

export default App
